import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./features/store";

import * as Sentry from "@sentry/react";

// Load environment variables
const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
const tracePropagationTargetString = process.env.REACT_APP_TRACE_PROPAGATION_TARGETS.split(',');
const tracePropagationTargets = tracePropagationTargetString.map(target =>
  target.startsWith('http') ? new RegExp(`^${target.replace(/\./g, '\\.').replace(/\//g, '\\/')}`) : target
)

Sentry.init({
  dsn: sentryDSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: tracePropagationTargets,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
